<template>
  <div class="prant-div">
    <template v-if="showBtn">
      <Button
        class="child-btn"
        type="primary"
        icon="md-add"
        @click="exportToExcel()"
      >
        {{ $t("export") }}
      </Button>
    </template>

    <Table
      border
      :columns="exlTitle"
      :data="tableDetails"
      ref="table"
      height="600;overflow:auto"
    >
    </Table>
  </div>
</template>

<script>
export default {
  props: {
    tableDetails: {
      type: Array,
    },
    exlTitle: {
      type: Array,
    },
  },
  data() {
    return {
      showBtn: false,
    };
  },
  mounted() {
    if (this.tableDetails[0].status != this.$t("ready")) {
      this.showBtn = true;
    }
  },
  methods: {
    exportToExcel() {
      this.$refs.table.exportCsv({
        filename: "SouQ Exl",
        original: false,
      });
    },
  },
};
</script>

<style>
.prant-div {
  position: relative;
}
.child-btn {
  position: absolute;
  right: 61px;
  top: -57px;
}
</style>